/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum StripeSessionStateEnum {
    Created = 'CREATED',
    Pending = 'PENDING',
    Paid = 'PAID',
    Canceled = 'CANCELED',
    Failed = 'FAILED'
}

export function StripeSessionStateEnumFromJSON(json: any): StripeSessionStateEnum {
    return StripeSessionStateEnumFromJSONTyped(json, false);
}

export function StripeSessionStateEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeSessionStateEnum {
    return json as StripeSessionStateEnum;
}

export function StripeSessionStateEnumToJSON(value?: StripeSessionStateEnum | null): any {
    return value as any;
}

